module.exports = __webpack_public_path__ + "img/friday.5475ffa7.png";